import React from "react";

// Keep failed editors open and prevent duplicate saves before React commits.
export default function useAsyncAction() {
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState(null);
  const pendingRef = React.useRef(false);
  const mounted = React.useRef(false);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  const run = async (action) => {
    if (pendingRef.current) return false;
    pendingRef.current = true;
    setPending(true);
    setError(null);
    try {
      await action();
      return mounted.current;
    } catch (failure) {
      if (mounted.current) setError(failure);
      return false;
    } finally {
      pendingRef.current = false;
      if (mounted.current) setPending(false);
    }
  };
  return { pending, error, run, clearError: () => setError(null) };
}
